import { useEffect, useState } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { WhyUs } from "@/components/site/WhyUs";
import { Filtration } from "@/components/site/Filtration";
import { Gallery } from "@/components/site/Gallery";
import { Reviews } from "@/components/site/Reviews";
import { Areas } from "@/components/site/Areas";
import { FAQ } from "@/components/site/FAQ";
import { QuoteSection } from "@/components/site/QuoteSection";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";
import { ChatWidget } from "@/components/site/ChatWidget";
import { startLenis, scrollToId } from "@/lib/smooth";

export default function Landing() {
  const [preset, setPreset] = useState(null);

  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  const onQuote = (service) => {
    if (service) setPreset({ service, t: Date.now() });
    scrollToId("quote");
  };

  return (
    <div className="overflow-x-clip" data-testid="landing-page">
      <Header onQuote={onQuote} />
      <main>
        <Hero onQuote={onQuote} />
        <Marquee />
        <Services onQuote={onQuote} />
        <WhyUs />
        <Filtration onQuote={onQuote} />
        <Gallery />
        <Reviews />
        <Areas />
        <FAQ />
        <QuoteSection preset={preset} />
      </main>
      <Footer />
      <MobileBar onQuote={onQuote} />
      <ChatWidget />
    </div>
  );
}
